export default __webpack_public_path__ + "static/media/img53.452d2152.jpg";